import {
  GET_SECURITY_UNLOADING_REPORTS_ERROR,
  GET_SECURITY_UNLOADING_REPORTS_REQUEST,
  GET_SECURITY_UNLOADING_REPORTS_SUCCESS,
} from './constants';
import { SecurityUnloadingReport } from './interfaces';

export const getSecurityUnloadingReportsRequest = (startDate: string, endDate: string, branchId: string) => ({
  type: GET_SECURITY_UNLOADING_REPORTS_REQUEST,
  payload: { startDate, endDate, branchId },
});

export const getSecurityUnloadingReportsSuccess = (reports: SecurityUnloadingReport[]) => ({
  type: GET_SECURITY_UNLOADING_REPORTS_SUCCESS,
  payload: { reports },
});

export const getSecurityUnloadingReportsError = (error: Error) => ({
  type: GET_SECURITY_UNLOADING_REPORTS_ERROR,
  payload: { error },
});

export type Actions =
  | ReturnType<typeof getSecurityUnloadingReportsRequest>
  | ReturnType<typeof getSecurityUnloadingReportsSuccess>
  | ReturnType<typeof getSecurityUnloadingReportsError>;
